import { createTheme } from '@material-ui/core';
import { DefaultTheme } from 'styled-components';

import baseTheme from '@/theme';

/**
 * @deprecated
 * Use default export from `'@/themes/sparkTheme'` instead.
 */
export const sparkTheme: DefaultTheme = {
  checkBox: {
    backgroundColor: '#F2F7F6',
    color: '#363334',
  },
  infoBox: {
    backgroundColor: '#F2F7F6',
    textColor: '#363334',
  },
  link: {
    color: '#00B894',
    fontWeight: 700,
  },
  button: {
    primary: {
      backgroundColor: '#067B65',
      disabledBackgroundColor: '#898989',
      textColor: '#FFFFFF',
      disabledTextColor: '#FFF',
    },
  },
  colors: {
    primaryNuetral: '#F7F6F5',
  },
};

export default createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    text: {
      primary: '#163258',
      secondary: '#6A717D',
    },
    primary: {
      light: '#00B894',
      main: '#067B65',
      dark: '#067B65',
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: '#234370',
      main: '#163258',
      dark: '#082143',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#067B6515',
    },
  },
  overrides: {
    ...baseTheme.overrides,
    MuiCheckbox: {
      root: {
        color: '#00B894',
      },
      colorSecondary: {
        '&$checked': {
          color: '#00B894',
        },
      },
    },
  },
});
